import create from "zustand";
import { devtools } from "zustand/middleware";

const store = (set, get) => ({
  office: "NY",
  setOffice: (office) => set({ office }),
  seats: [],
  seatMapNY0: [0],  
  seatMapNY1: [1, 2, 3],
  seatMapNY2: [
    [4, 5, 6, 7, 8],
    [9, 10, 11, 12, 13]
  ],
  seatMapNY3: [
    [14, 15, 16, 17],
    [18, 19, 20, 21],
  ],
  seatMapNY4: [
    [22, 23, 24, 25, 26],
    [27, 28, 29, 30, 31],
  ],  
  seatMapNY5: [
    [32, 33, 34, 35, 36],
    [37, 38, 39, 40, 41],
  ],  
  seatMapNY6: [42, 43], 
  seatMapTX1: [25, 0, 1, 2, 26],
  seatMapTX2: [
    [3, 4, 5],
    [6, 7, 8],
  ],
  seatMapTX3: [
    [9, 10, 11, 12],
    [13, 14, 15, 16],
    [17, 18, 19, 20],
    [21, 22, 23, 24],
    [27, 28, 29],
  ],
  refreshSeats: async () => {
    set({ seats: [] });
    const response = await fetch(
      process.env.REACT_APP_DB_URL + "/seats/" + get().office
    );
    const seats = await response.json();
    console.log(seats);
    set({ seats: seats });
  },
  getSeated: async (name, seat_id) => {
    const response = await fetch(
      `${process.env.REACT_APP_DB_URL}/get_seated/${name}/${seat_id}`
    );
    const seated = await response.json();
    // console.log(name, seated);
    return seated;
  },
  getSeat: (seatIndex) => get().seats[seatIndex],
  setSeat: (seatIndex, name) => {
    const params = {
      method: "POST",
      body: JSON.stringify({
        office: get().office,
        seat_id: get().seats[seatIndex].seat_id,
        name: name === "" ? get().seats[seatIndex].name : name,
        taken: name === "" ? 0 : 1,
      }),
    };
    fetch(process.env.REACT_APP_DB_URL + "/update_seat", params);
    // const user = taken === 1 ? name : "";
    console.log(seatIndex, name)

    return set((state) => ({
      seats: [
        ...state.seats.slice(0, seatIndex),
        { ...state.seats[seatIndex], name },
        ...state.seats.slice(seatIndex + 1),
      ],
    }));
  },
});

const useStore = create(
  process.env.NODE_ENV !== "production" ? devtools(store) : store
);

export default useStore;
